/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
import { Button, CloseBtn } from '@styles/button.style'
import { observer } from 'mobx-react'
import _ from 'lodash'
import { Content, ModalBg } from '@styles/base.style'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
import { Theme } from '@themes/theme'
import { GeneralPopupTit } from './index.style'

export interface GeneralPopupOptions {
  wrapClassName?: string
  className?: string
  isScroll?: boolean
  custom?: boolean
  clsBtn?: boolean /* full modal 하단 플로팅 닫기 버튼*/
  closeCallback?: (closeType?: PopupCloseType) => void
  contentClassName?: string
  isUnableCloseBg?: boolean
}

export interface GeneralPopupProps {
  contentBody: React.ReactElement
  title: string
  options: GeneralPopupOptions
  titleCustom: React.ReactNode
  popupId: string
}

export interface PopupCloseType {
  isTitleClose?: boolean
  isFloatingClose?: boolean
  isModalMaskClose?: boolean
}

const GeneralPopup: React.FC<GeneralPopupProps> = (props: GeneralPopupProps) => {
  const { globalStore } = useRootStore()

  const {
    contentBody,
    title,
    titleCustom,
    options,
    popupId,
  } = props

  const { isUnableCloseBg } = options

  const onCloseHandler = (closeType?: PopupCloseType) => {
    const isButtonClose = closeType?.isTitleClose || closeType?.isFloatingClose || false

    // isUnableCloseBg가 true면 뒷배경 클릭해도 닫히지 않도록 처리
    if (isUnableCloseBg && !isButtonClose) {
      return
    }
    const { closeCallback } = options
    globalStore.closeGeneralPopup()
    if (closeCallback && _.isFunction(closeCallback)) {
      closeCallback(closeType)
    }
  }

  let customTit
  let closeBtn
  let modalWrapClassName = ''
  let modalClassName = 'full-modal message'
  let contentClass = 'full-modal'
  let contentCss = (theme: Theme) => css`height: 100%;
    overflow: auto;
    text-align: left;`
  if (options) {
    const { wrapClassName: wrapClsName, className: clsName, isScroll, custom, clsBtn, contentClassName } = options
    if (wrapClsName) {
      modalWrapClassName += `${wrapClsName}`
    }
    if (clsName) {
      modalClassName += ` ${clsName}`
    }
    if (contentClassName) {
      contentClass = contentClassName
    }
    if (!isScroll) {
      contentCss = (theme: Theme) => css`height: 100%;
        overflow: hidden;
        text-align: left;`
    }
    if (custom) {
      customTit = (
        <Fragment>
          {titleCustom}
        </Fragment>
      )
    }
    if (clsBtn) {
      if (isMobile) {
        closeBtn = (
          <Button
            TP
            float
            onClick={() => onCloseHandler({ isFloatingClose: true })}
            className="full-modal-cls-btn"
          >
            <div className="btn-bg">
              <span className="cls-ico"/>
            </div>
          </Button>
        )
      }
    }
  }
  return (
    <Modal
      key={popupId}
      popup
      visible
      animated={false}
      title={
        <GeneralPopupTit>
          {customTit}
          <h1 className="title">{title}</h1>
          <Button
            onClick={() => onCloseHandler({ isTitleClose: true })}
            className="close-btn"
            css={CloseBtn}
          >
            <span className="close-txt">닫기</span>
          </Button>
        </GeneralPopupTit>
      }
      wrapClassName={modalWrapClassName}
      className={modalClassName}
      onClose={onCloseHandler}
      maskClosable={false}
    >
      <Content css={contentCss} className={contentClass}>
        {contentBody}
      </Content>

      {closeBtn}

      {/* 빠른 적용을 위해 임시로 적용 */}
      <ModalBg onClick={() => onCloseHandler({ isModalMaskClose: true })}/>
    </Modal>
  )
}
export default observer(GeneralPopup)
